export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = match[1] ? '+1 ' : ''
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return null
}

export function maskPhoneNumber(number: string): string {
  // Remove all non-digit characters from the number
  const cleanedNumber = number.replace(/\D/g, '')

  // Check if the number matches the expected format
  const isMatch = /^(\d{3})(\d{3})(\d{4})$/.test(cleanedNumber)

  // If the number matches, apply the mask; otherwise, return the original number
  if (isMatch) {
    const [, areaCode, firstPart, secondPart] = cleanedNumber.match(/^(\d{3})(\d{3})(\d{4})$/)!
    return `(${areaCode}) ${firstPart}-${secondPart}`
  }

  return number
}

export function validatePhoneNumber(number: string): boolean {
  const cleanedNumber = number.replace(/\D/g, '')

  const isMatch = /^1?\d{10}$/.test(cleanedNumber)

  return isMatch
}

export function createInaudibleBuffer(context) {
  const bufferSize = 1;
  const buffer = context.createBuffer(1, bufferSize, context.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) {
    data[i] = 0; // Silent audio data
  }
  return buffer;
}


export function playInaudibleSound(context, buffer, iterations, interval) {
  const source = context.createBufferSource();
  source.buffer = buffer;
  source.loop = true;
  source.connect(context.destination);
  source.start(0);

  let currentIteration = 1;
  const intervalId = setInterval(() => {
    if (currentIteration >= iterations) {
      clearInterval(intervalId);
      source.stop(0);
    }
    
    currentIteration++;
  }, interval);
}
